import '../plugins/TouchNavPlugin.js';
import '../plugins/ResponsiveHelper.js';

// drop menu init
export default function initDropMenu() {

	jQuery('.main-nav_desktop-drop').each((i, drop) => {
		const $nav = jQuery(drop).find('> ul');
		const $drops = $nav.find('.drop');
		const $items = $nav.find('> li');
		const $parent = $nav.closest('.nav-drop-inner');
		const resizeObserver = new ResizeObserver(() => {
			const $activeItem = $items.filter('.hover');
			const $drop = $activeItem.length ? jQuery($activeItem[0].drop) : jQuery();

			if ($drop.length) {
				$nav.css('height', Math.max($nav.innerHeight(), $drop.innerHeight()));
			} else {
				$nav.css('height', '');
			}
		});

		$nav.each(function() {
			new TouchNav({
				navBlock: this,
				menuDrop: '.drop',
				// hideOnLeave: false
			});
		});

		function itemhoverHandler(e, self) {
			const $item = jQuery(self.currentItem);
			const $drop = jQuery(self.currentItem.drop);

			if ($drop.length) {
				$parent.addClass('nav-drop-shown');

				$nav.css('height', Math.max($nav.innerHeight(), $drop.innerHeight()));
			}
		}

		function itemleaveHandler(e, self) {
			const $item = jQuery(self.currentItem);
			const $drop = jQuery(self.currentItem.drop);

			if (!$item.closest('li.hover').length) {
				$nav.css('height', '');
				$parent.removeClass('nav-drop-shown');
			}
		}

		$items.on('itemhover', itemhoverHandler);
		$items.on('itemleave', itemleaveHandler);

		resizeObserver.observe(document.body);
	});
}